import BaseRepository from '@/api/repositories/BaseRepository';

class DamageAssessorRepository extends BaseRepository {
	get endpoint() {
		return 'api/damageassessors';
	}

	//gets all damage assessors of a specific company; added for admins
	damageAssessorsOfCompany(companyId, params = {}) {
		return this.get(`ofCompany/${companyId}`, params);
	}
}

export default new DamageAssessorRepository();
